import React, {useContext} from "react";
import styled from "styled-components";
import ItemMenu from "./components/ItemMenu";
import {ReactComponent as UserIcon} from "../../assets/icons/user.svg";
import {GlobalContext} from "../../context/GlobalContext";

export default function Nav({base, logoInvert}) {
   const {sessionStarted} = useContext(GlobalContext);
   return (
      <Content className="navContent">
         <ul>
            <ItemMenu base={base} activeClassName="navCurrent" path="/preguntas_frecuentes" name="Preguntas frecuentes" />
            <ItemMenu base={base} activeClassName="navCurrent" path="/contacto" name="contacto" />
            {sessionStarted ? (
               <ItemMenu
                  base={base}
                  path="/perfil"
                  activeClassName="navCurrent"
                  name={
                     <span>
                        <UserIcon width="12px" height="12px" className="icon" /> Mi Perfil{" "}
                     </span>
                  }
               />
            ) : (
               <ItemMenu
                  base={base}
                  path="/iniciar_sesion"
                  activeClassName="navCurrent"
                  name={
                     <span>
                        <UserIcon width="12px" height="12px" className="icon" /> Iniciar sesión{" "}
                     </span>
                  }
               />
            )}
         </ul>
      </Content>
   );
}

const Content = styled.div`
   width: 100%;
   & ul {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      & li:nth-child(2) {
         padding: 0 1em;
         margin: 0 1em;
         position: relative;

         :after,
         :before {
            content: "";
            border-left: 1px solid ${props => props.theme.primary};
            position: absolute;
            height: 70%;
            top: 15%;
         }

         :before {
            left: 0;
         }

         :after {
            right: 0;
         }
      }
   }
`;
